import { Injectable } from '@angular/core';
import { InboxService } from './inbox.service';

@Injectable({
  providedIn: 'root'
})
export class CleanupService {
 	constructor(
 		public inboxService: InboxService
 	){}

 	doCleanup(){
 		//Clear everything needed
 		this.inboxService.clearFirebaseEvents();
 	}	
}
	